module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-01.336be095.svg";